import { useEffect, useState } from 'react';

/**
 * Is the network gone right now? Used to say so BEFORE the submitter taps
 * (UX review C8): the queue existed from M1.5 (DD-41), but it only showed itself as a
 * receipt afterwards, and «Ingen nett» (no connection) then reads as if something went wrong.
 *
 * `navigator.onLine` is an offer, not a truth — it says the machine has an
 * interface up, not that the server answers. So it only changes what we SAY;
 * the send is attempted regardless, and the queue takes what fails.
 */
export function useOffline(): boolean {
  const [offline, setOffline] = useState(() => typeof navigator !== 'undefined' && navigator.onLine === false);
  useEffect(() => {
    const på = () => setOffline(false);
    const av = () => setOffline(true);
    window.addEventListener('online', på);
    window.addEventListener('offline', av);
    return () => {
      window.removeEventListener('online', på);
      window.removeEventListener('offline', av);
    };
  }, []);
  return offline;
}
